var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionInArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6565 0.17895L2.63682 10.1987L2.62975 5.1287H0.635707V13.614H9.12099V11.6199L4.05103 11.6129L14.0707 1.59316L12.6565 0.17895Z",
    fill: "#0BB685"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionInArrow);
export default __webpack_public_path__ + "static/media/transaction-in-arrow.499be83588e5251ea9b828ad134ce62c.svg";
export { ForwardRef as ReactComponent };